export default function SettingsSkeleton() {
    return (
        <div className="space-y-6 animate-pulse">
            {[0, 1].map((section) => (
                <div key={section}>
                    <div className="h-4 w-32 bg-[#e2e8f0] rounded mb-3" />
                    <div className="rounded-xl border border-[#e2e8f0] divide-y divide-[#f1f5f9]">
                        {[0, 1, 2].map((row) => (
                            <div key={row} className="flex items-center justify-between px-4 py-3.5">
                                <div className="space-y-2 flex-1 mr-4">
                                    <div className="h-3.5 w-40 bg-[#e2e8f0] rounded" />
                                    <div className="h-3 w-56 bg-[#f1f5f9] rounded" />
                                </div>
                                <div className="h-6 w-11 bg-[#e2e8f0] rounded-full flex-shrink-0" />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
